import React from "react";
import { CONTROL, LABEL } from "./controlStyles";

export default function Input({ label, id, error, className = "", ...rest }) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, "-");
  const widthClass = /(^|\s)w-/.test(className) ? "" : "w-full";

  const control = (
    <input
      id={inputId}
      aria-invalid={error ? "true" : undefined}
      className={`${CONTROL} ${widthClass} ${error ? "border-danger dark:border-danger" : ""} ${className}`}
      {...rest}
    />
  );

  if (!label) return control;

  return (
    <label htmlFor={inputId} className="flex flex-col gap-1.5">
      <span className={LABEL}>{label}</span>
      {control}
      {error && <span className="text-xs text-danger-dark dark:text-danger-light">{error}</span>}
    </label>
  );
}
